import React from "react"
import { MessagesShell } from "#/pages/messages-shell"

/**
 * ONE PAGE SERVES EVERYONE at /messages.
 *
 * This used to fork on `programFlags.isConsumer`, sending consumers to a cloned page and everybody else
 * to the shell, and gate the whole route on the flags having resolved. Both are gone: the shell serves
 * every member, and the flags decide one thing inside it — whether there is a tab bar and whether the
 * provider routes have any content (see `MessagesShell`). Gating the ROUTE on them would have made every
 * member wait on a query that only some of them are affected by, and would have redirected a consumer's
 * provider deep link before the answer arrived.
 */
export function MessagesRoute(): JSX.Element {
  return <MessagesShell />
}
